import React, { useState } from "react";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Snackbar, Alert as MuiAlert } from "@mui/material";
import API_URL from "../Config"; // Ensure you have this file for API base URL
import "./ChangePassword.css";
import { useParams, useNavigate } from "react-router-dom";

export default function ChangePassword() {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const { user_id } = useParams();

  // Form Validation Schema
  const validationSchema = Yup.object({
    newPassword: Yup.string()
      .min(6, "New password must be at least 6 characters")
      .required("New password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
      .required("Confirm password is required"),
  });

  const formik = useFormik({
    initialValues: {
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        const authKey = localStorage.getItem("authKey");
        const response = await axios.put(
          `${API_URL}/api/edit_user_password/${user_id}`,
          {
            password: values.newPassword,
          },
          {
            headers: { Authorization: `Bearer ${authKey}` },
          }
        );

        if (response.status === 200) {
          setSnackbarSeverity("success");
          setSnackbarMessage("Password changed successfully!");
          setSnackbarOpen(true);
          resetForm();
        } else {
          throw new Error("Failed to change password");
        }
      } catch (error) {
        console.error("Error changing password:", error);
        setSnackbarSeverity("error");
        setSnackbarMessage("Error changing password. Please try again.");
        setSnackbarOpen(true);
      }
    },
  });

  return (
    <div className="password-update-container">
      <h2 className="password-title">Change Password</h2>

      <form onSubmit={formik.handleSubmit}>
        {/* Current Password */}

        {/* New Password */}
        <div className="password-input-group">
          <label>New Password</label>
          <input
            type="password"
            name="newPassword"
            placeholder="Enter new password"
            value={formik.values.newPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.newPassword && formik.errors.newPassword && (
            <div className="password-error">{formik.errors.newPassword}</div>
          )}
        </div>

        {/* Confirm Password */}
        <div className="password-input-group">
          <label>Confirm Password</label>
          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirm new password"
            value={formik.values.confirmPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.confirmPassword && formik.errors.confirmPassword && (
            <div className="password-error">{formik.errors.confirmPassword}</div>
          )}
        </div>

        {/* Submit Button */}
        <button type="submit" className="password-update-btn">
          Update Password
        </button>
      </form>

      {/* Snackbar Notification */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity}>
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
}
